module.exports = "/_next/static/images/offers1-fb1142a19909c3486e56682bdfc045d9.jpg.webp";